import { createSlice } from '@reduxjs/toolkit'
import { decryptText } from '../../utils/utils';

const auth = JSON.parse(decryptText(localStorage.getItem('user')) || '{}');

const initialState = {
	user: auth.user || null,
	token: auth.token || null,
	expires_at: auth.expires_at || null,
}

const authUserSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setAuthUser: (state, action) => {
			return {...state, ...action.payload};
		},
		deleteAuthUser: () => {
			return { user: {}, token: null, expires_at: null };
		}
	},
});

export const { setAuthUser, deleteAuthUser } = authUserSlice.actions;

export default authUserSlice.reducer